import { GetterTree } from 'vuex';
import { NFCState } from './state';
import { RootState } from '@/plugins/store';
import { Site } from '@/models/Site';

export const getters: GetterTree<NFCState, RootState> = {
    getNFCItems(state) {
        return state.NFC;
    },
    getNFCHistorique(state) {
        return state.nfcHistorique;
    },
    getNFCFilterSite(state): Array<Site> {
        return state.filterSite;
    },
    getNFCFilterLocalisation(state): string {
        return state.filterLocalisation;
    },
    getNFCPage(state) {
        return state.page;
    },
    getNFCNbOfPages(state) {
        return state.nbOfPages;
    },
    getNFCScroll(state) {
        return state.scroll;
    },
    getNFCSort(state) {
        return state.sort;
    },
    getNFCCount(state) {
        return state.count;
    },
    getNFCTableHeader(state) {
        return state.tableHeader;
    },
    getHistoriqueNFCTableHeader(state) {
        return state.historiqueTableHeader;
    },
    getNFCIsLoading(state) {
        return state.isLoading;
    },
    getNumeroNFC(state) {
        return state.numeroNFC;
    },
    getHistoriqueSort(state) {
        return state.sortHistorique;
    },
    getNbOfHistoriquePage(state) {
        return state.nbOfHistoriquePages;
    },
    getHistoriquePage(state) {
        return state.historiquePage;
    },
    getHistoriqueIsLoading(state) {
        return state.isHistoriqueLoading;
    },
    getHistoriqueScroll(state) {
        return state.historiqueScroll;
    }
};
